export const sportIconsCSSlink = 'https://sharedassets.bcapps.org/sport-icons/import.css';
